import React from 'react';
import { Hide } from 'pcln-design-system';
import { StyledDotGroup } from './Dots.styles';
const Dots = () => /*#__PURE__*/React.createElement(Hide, {
  xs: true,
  sm: true
}, /*#__PURE__*/React.createElement(StyledDotGroup, {
  "data-testid": "dot_group"
}));
export { Dots };